import { Clock, Users, Boxes, Calculator, Sparkles, LifeBuoy, Ruler, LayoutGrid } from "lucide-react";

const MAP = { Clock, Users, Boxes, Calculator, Sparkles, LifeBuoy, Ruler };

export function ModuleIcon({ name, ...props }) {
  const Cmp = MAP[name] || LayoutGrid;
  return <Cmp {...props} />;
}
